import { InvitationsService } from '@invitations/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RejectGameInvitationPathParams } from '@core-http';

export class DeclineInvitationCommandHandler {
  private readonly invitationsService: InvitationsService = inject(InvitationsService);

  decline(invitationId: string): Observable<void> {
    const pathParams: RejectGameInvitationPathParams = { invitationId };

    return this.invitationsService.decline(pathParams);
  }
}
